import React from 'react';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const handleNavLinkClick = function(pageType) {
	window.location.href =
		pageType === 'homepage' || pageType === 'aboutus' || pageType === 'careers'
			? '/'
			: '/monthly';
};

const GiNavToggler = ({ logo, pageType }) => (
	<div className="d-flex" onClick={() => handleNavLinkClick(pageType)}>
		<div>
			{logo === 'white' ? (
				<img
					src={
						pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'careers'
							? `${config.cdnUrl}/static/giveindia-white.svg`
							: `${config.cdnUrl}/static/images/give-monthly-giving-white-2x.png`
					}
					height="30"
					alt=""
				/>
			) : null}
			{logo === 'black' ? (
				<img
					src={
						pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'contactus' ||
						pageType === 'newsletters' ||
						pageType === 'terms' ||
						pageType === 'privacy' ||
						pageType === 'sitemap' ||
						pageType === 'giveassured' ||
						pageType === 'careers'
							? `${config.cdnUrl}/static/images/giveindia-logo-color-transparent.png`
							: `${config.cdnUrl}/static/images/give-monthly-giving-2x.png`
					}
					height="30"
					alt=""
				/>
			) : null}
			{logo !== 'black' && logo !== 'white' ? (
				<img
					src={
						pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'contactus' ||
						pageType === 'newsletters' ||
						pageType === 'terms' ||
						pageType === 'privacy' ||
						pageType === 'sitemap' ||
						pageType === 'giveassured' ||
						pageType === 'careers'
							? `${config.cdnUrl}/static/images/giveindia-logo-v2.jpg`
							: `${config.cdnUrl}/static/images/give-monthly-giving-2x.jpg`
					}
					height={
						pageType === 'homepage' ||
						pageType === 'aboutus' ||
						pageType === 'contactus' ||
						pageType === 'newsletters' ||
						pageType === 'terms' ||
						pageType === 'privacy' ||
						pageType === 'sitemap' ||
						pageType === 'giveassured' ||
						pageType === 'careers'
							? '35'
							: '30'
					}
					alt=""
				/>
			) : null}
		</div>
	</div>
);

export default GiNavToggler;
